import React from 'react';
import { connect } from 'react-redux';

import Home from 'screens/Home';
import Login from 'screens/Login';
import Purchase from 'screens/Purchase';
import PurchaseHistory from 'screens/PurchaseHistory';
import UnpaidPurchase from 'screens/UnpaidPurchase';
import ResetPassword from 'screens/ResetPassword';
import Account from 'screens/Account';
import Renew from 'screens/Renew';
import Billing from 'screens/Billing';
import AddCard from 'screens/AddCard';
import SprintSubscriptionScreen from 'screens/Subscription/sprint';
import AttSubscriptionScreen from 'screens/Subscription/att';
import QuickSubscriptionScreen from 'screens/Subscription/quick';
import SprintAddDataScreen from 'screens/AddData/sprint';
import AttAddDataScreen from 'screens/AddData/att';
import QuickAddDataScreen from 'screens/AddData/quick';
import SprintAddDataPurchase from 'screens/AddDataPurchase/sprint';
import AttAddDataPurchase from 'screens/AddDataPurchase/att';
import QuickAddDataPurchase from 'screens/AddDataPurchase/quick';
import SprintInsuranceConfirmScreen from 'screens/InsuranceConfirm/sprint';
import SprintInsurancePlanScreen from 'screens/InsurancePlan/sprint';
import SprintInsuranceDeviceScreen from 'screens/InsuranceDevice/sprint';
import SprintInsuranceScreen from 'screens/Insurance/sprint';
import AttInsuranceConfirmScreen from 'screens/InsuranceConfirm/att';
import AttInsurancePlanScreen from 'screens/InsurancePlan/att';
import AttInsuranceDeviceScreen from 'screens/InsuranceDevice/att';
import AttInsuranceScreen from 'screens/Insurance/att';
import QuickInsuranceScreen from 'screens/Insurance/quick';
import QuickInsuranceDeviceScreen from 'screens/InsuranceDevice/quick';
import QuickInsurancePlanScreen from 'screens/InsurancePlan/quick';
import QuickInsuranceConfirmScreen from 'screens/InsuranceConfirm/quick';
import InsurancePurchaseScreen from 'screens/InsurancePurchase';
import InsuranceEligibilityScreen from 'screens/InsuranceEligibility';
import OrderSimScreen from 'screens/OrderSim';
import PaymentArrangementRequest from 'screens/PaymentArrangementRequest';

export const Screen = ({ id, params }) => {
  switch (id) {
    case 'HOME':
      return <Home />;
    case 'LOGIN':
      return <Login />;
    case 'PURCHASE':
      return <Purchase id={params.purchaseId} />;
    case 'PURCHASE_HISTORY':
      return <PurchaseHistory />;
    case 'UNPAID_PURCHASE':
      return <UnpaidPurchase id={params.purchaseId} />;
    case 'RESET_PASSWORD':
      return <ResetPassword />;
    case 'ACCOUNT':
      return <Account />;
    case 'RENEW':
      return <Renew />;
    case 'BILLING':
      return <Billing />;
    case 'ADD_CARD':
      return <AddCard />;
    case 'SPRINT_SUBSCRIPTION':
      return <SprintSubscriptionScreen subId={params.subId} />;
    case 'ATT_SUBSCRIPTION':
      return <AttSubscriptionScreen subId={params.subId} />;
    case 'QUICK_SUBSCRIPTION':
      return <QuickSubscriptionScreen subId={params.subId} />;
    case 'SPRINT_ADD_DATA':
      return <SprintAddDataScreen subId={params.subId} />;
    case 'ATT_ADD_DATA':
      return <AttAddDataScreen subId={params.subId} />;
    case 'QUICK_ADD_DATA':
      return <QuickAddDataScreen subId={params.subId} />;
    case 'SPRINT_ADD_DATA_PURCHASE':
      return <SprintAddDataPurchase subId={params.subId} planId={params.planId} />;
    case 'ATT_ADD_DATA_PURCHASE':
      return <AttAddDataPurchase subId={params.subId} planId={params.planId} />;
    case 'QUICK_ADD_DATA_PURCHASE':
      return <QuickAddDataPurchase subId={params.subId} planId={params.planId} />;
    case 'SPRINT_INSURANCE_CONFIRM':
      return <SprintInsuranceConfirmScreen subId={params.subId} sku={params.sku} insPlanId={params.insPlanId} />;
    case 'SPRINT_INSURANCE_PLAN':
      return <SprintInsurancePlanScreen subId={params.subId} sku={params.sku} />;
    case 'SPRINT_INSURANCE_DEVICE':
      return <SprintInsuranceDeviceScreen subId={params.subId} />;
    case 'SPRINT_INSURANCE':
      return <SprintInsuranceScreen subId={params.subId} />;
    case 'ATT_INSURANCE_CONFIRM':
      return <AttInsuranceConfirmScreen subId={params.subId} sku={params.sku} insPlanId={params.insPlanId} />;
    case 'ATT_INSURANCE_PLAN':
      return <AttInsurancePlanScreen subId={params.subId} sku={params.sku} />;
    case 'ATT_INSURANCE_DEVICE':
      return <AttInsuranceDeviceScreen subId={params.subId} />;
    case 'ATT_INSURANCE':
      return <AttInsuranceScreen subId={params.subId} />;
    case 'QUICK_INSURANCE':
      return <QuickInsuranceScreen subId={params.subId} />;
    case 'QUICK_INSURANCE_DEVICE':
      return <QuickInsuranceDeviceScreen subId={params.subId} />;
    case 'QUICK_INSURANCE_PLAN':
      return <QuickInsurancePlanScreen subId={params.subId} sku={params.sku} />;
    case 'QUICK_INSURANCE_CONFIRM':
      return <QuickInsuranceConfirmScreen subId={params.subId} sku={params.sku} insPlanId={params.insPlanId} />;
    case 'INSURANCE_PURCHASE':
      return <InsurancePurchaseScreen purchaseId={params.purchaseId} contractId={params.contractId} />;
    case 'INSURANCE_ELIGIBILITY':
      return <InsuranceEligibilityScreen />;
    case 'ORDER_SIM':
      return <OrderSimScreen />;
    case 'PAYMENT_ARRANGEMENT_REQUEST':
      return <PaymentArrangementRequest />;
    default:
      return null;
  }
};

const mapStateToProps = (state) => ({
  ...state.routing
});

export default connect(
  mapStateToProps
)(Screen);
